// src/pages/Services.js
import React from "react";
import { useTranslation } from "react-i18next";
import { FaLaptopCode, FaPalette, FaRocket, FaSearch, FaHandsHelping, FaSyncAlt, FaBolt, FaCogs, FaClock } from "react-icons/fa";
import { Helmet } from "react-helmet-async";

const Services = () => {
  const { t } = useTranslation();

  const whyChooseUs = [
    { icon: <FaBolt className="text-primary me-3" />, text: t("services.c3") },
    { icon: <FaCogs className="text-primary me-3" />, text: t("services.c4") },
    { icon: <FaClock className="text-primary me-3" />, text: t("services.c5") },
    { icon: <FaLaptopCode className="text-primary me-3" />, text: t("services.c6") },
  ];


  const servicesData = [
    { icon: <FaPalette className="text-primary mb-3" size={40} />, title: t("services.t1"), desc: t("services.t2") },
    { icon: <FaLaptopCode className="text-primary mb-3" size={40} />, title: t("services.t3"), desc: t("services.t4") },
    { icon: <FaRocket className="text-primary mb-3" size={40} />, title: t("services.t5"), desc: t("services.t6") },
    { icon: <FaSearch className="text-primary mb-3" size={40} />, title: t("services.t7"), desc: t("services.t8") },
    { icon: <FaHandsHelping className="text-primary mb-3" size={40} />, title: t("services.t9"), desc: t("services.t10") },
    { icon: <FaSyncAlt className="text-primary mb-3" size={40} />, title: t("services.t11"), desc: t("services.t12") },
  ];

  return (
    <>
    <Helmet>
      <html lang="sr" />

      {/* Title i meta description */}
      <title>Naše Usluge | AlphaPremiumSolutions</title>
      <meta
        name="description"
        content="Pregled naših profesionalnih web usluga: izrada sajtova, SEO optimizacija, razvoj web aplikacija i digitalna rešenja za firme u Srbiji."
      />
      <meta
        name="keywords"
        content="web dizajn, izrada sajtova, SEO optimizacija, web aplikacije, digitalna rešenja, Srbija"
      />
      <meta name="author" content="AlphaPremiumSolutions" />
      <meta name="robots" content="index, follow" />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Naše Usluge | AlphaPremiumSolutions" />
      <meta
        property="og:description"
        content="Profesionalne web usluge: izrada sajtova, SEO optimizacija i razvoj web aplikacija za firme u Srbiji."
      />
      <meta property="og:url" content="https://alphapremiumsolutions.com/services" />
      <meta property="og:locale" content="sr_RS" />
      <meta property="og:image" content="https://alphapremiumsolutions.com/images/og-image.jpg" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Naše Usluge | AlphaPremiumSolutions" />
      <meta
        name="twitter:description"
        content="Pregled svih profesionalnih web usluga AlphaPremiumSolutions: izrada sajtova, SEO optimizacija, razvoj web aplikacija."
      />
      <meta name="twitter:image" content="https://alphapremiumsolutions.com/og-image.jpg" />

      {/* Canonical */}
      <link rel="canonical" href="https://alphapremiumsolutions.com/services" />

      {/* JSON-LD – LocalBusiness + OfferCatalog */}
      <script type="application/ld+json">
        {`
        {
          "@context": "https://schema.org",
          "@type": ["LocalBusiness", "ProfessionalService"],
          "@id": "https://alphapremiumsolutions.com/#business",
          "name": "AlphaPremiumSolutions",
          "url": "https://alphapremiumsolutions.com",
          "logo": "https://alphapremiumsolutions.com/logo.png",
          "image": "https://alphapremiumsolutions.com/og-image.jpg",
          "description": "Pregled naših profesionalnih web usluga: izrada sajtova, SEO optimizacija i razvoj web aplikacija u Srbiji.",
          "email": "info@alphapremiumsolutions.com",
          "telephone": "+381638597131",
          "priceRange": "€€",
          "areaServed": {
            "@type": "Country",
            "name": "Serbia"
          },
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Beograd",
            "addressRegion": "RS",
            "addressCountry": "RS"
          },
          "sameAs": [
            "https://www.linkedin.com/company/alphapremiumsolutions",
            "https://www.instagram.com/alphapremiumsolutions",
            "https://www.facebook.com/alphapremiumsolutions"
          ],
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Naše Web Usluge",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": { "@type": "Service", "name": "Izrada Web Sajtova" }
              },
              {
                "@type": "Offer",
                "itemOffered": { "@type": "Service", "name": "SEO Optimizacija" }
              },
              {
                "@type": "Offer",
                "itemOffered": { "@type": "Service", "name": "Razvoj Web Aplikacija" }
              },
              {
                "@type": "Offer",
                "itemOffered": { "@type": "Service", "name": "Digitalna Rešenja i Konsalting" }
              }
            ]
          }
        }
        `}
      </script>
    </Helmet>


    <section className="py-5 bg-light">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">{t("body.t15")}</h2>
          <p className="text-muted fs-5">{t("body.t16")}</p>
        </div>

        <div className="row g-4">
          {servicesData.map((s, i) => (
            <div className="col-md-6 col-lg-4" key={i}>
              <div className="card h-100 border-0 shadow-sm rounded-4 hover-scale">
                <div className="card-body text-center p-4">
                  {s.icon}
                  <h5 className="fw-bold mt-3">{s.title}</h5>
                  <p className="text-muted mt-2">{s.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <br></br>
       {/* Zašto izabrati nas sekcija */}
        <div className="text-center mb-4">
          <h3 className="fw-bold">{t("services.c1")}</h3>
          <p className="text-muted fs-6">{t("services.c2")}</p>
        </div>
        <div className="row justify-content-center g-3 container-fluid">
          {whyChooseUs.map((item, i) => (
            <div className="col-md-6 col-lg-3 d-flex align-items-start" key={i}>
              <div className="fs-4">{item.icon}</div>
              <p className="ms-2 mb-0 text-muted">{item.text}</p>
            </div>
          ))}
        </div>

      {/* Dodajemo mali CSS za hover animaciju */}
      <style jsx>{`
        .hover-scale {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .hover-scale:hover {
          transform: translateY(-8px);
          box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);
        }
      `}</style>
    </section>
    </>
  );
};

export default Services;